import React from 'react'
import Activity from '../../pages-partial/AdminActivity'

const AdminActivity = () => {
  return (
    <div><Activity /></div>
  )
}

export default AdminActivity